import ApiService from "@/services/api.service";
export async function collectCoins(objectId){
    const response = await ApiService.get("object/"+objectId+"/coins/collect");
    return response.data;
}